export default __webpack_public_path__ + "static/media/KiitBorder.49cc7efd.png";